import { render, staticRenderFns } from "./SidebarUserMenu.vue?vue&type=template&id=228967c0&scoped=true"
import script from "./SidebarUserMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarUserMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarUserMenu.vue?vue&type=style&index=0&id=228967c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228967c0",
  null
  
)

export default component.exports